module.exports = __webpack_public_path__ + "static/media/El Salvador.a637f8cb.png";